<template>
    <div class="container">
        <md-dialog :md-active.sync="modalCrear" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.codigo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="codigo" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.descripcion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="descripcion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="text-center">
                    <b-col cols="12 mt-4">
                        <h5>{{ labels.caracteristica }}</h5>
                    </b-col>
                </b-row>
                <div id="contenedor">
                    
                </div>
                <b-row class="d-flex justify-content-center">
                    <md-button style="background-color: #2e507a; width: 30px; height: 30px;" class="md-fab md-primary" @click="addCaracteristica()">
                        <md-icon>add</md-icon>
                    </md-button>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="guardarTipoActivo">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import TipoActivo from '../../../services/TipoActivo'
import TipoActivoCaracteristica from '../../../services/TipoActivoCaracteristica'

const cantFilaCaract = []
const listCaracteristicas = []
let objList = {}
let cont = 0

export default {
    name:'Crear',
    props:['modalCrear'],
    data:() => ({
        codigo : "",
        descripcion : "",
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Crear tipo activo",
                    codigo : "Código",
                    descripcion : "Descripción",
                    caracteristica: "Caracteristicas",
                    save : "Guardar",
                    close : "Cerrar"
                }
            }else{
                return {
                    title: "Create active type",
                    codigo : "Code",
                    descripcion : "Description",
                    caracteristica: "Characteristics",
                    save : "Sava",
                    close : "Close"
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        guardarTipoActivo(){

            if(cantFilaCaract.length == 0){
                return this.$toast.error('Debe agregar mínimo una caracteristica.')
            }

            if(document.getElementById('caracteristica'+0).value == ''){
                this.$toast.error('Debe agregar la caracteristica.')
                location. reload()
                return
            }

            cantFilaCaract.forEach((e,ind) => {
                console.log(e);
                objList = {
                    'codTipoActivo' : parseInt(this.codigo,10),
                    'codCaracteristica' : parseInt(document.getElementById('caracteristica'+ind).value,10),
                    'caracteristica' : document.getElementById('valor'+ind).value,
                    'idUser' : this.$store.state.userId
                }
                listCaracteristicas.push(objList)
            })
            // console.log(listCaracteristicas);

            TipoActivoCaracteristica.createTipoActivoCaract(listCaracteristicas)
            .then((res) => {
                if(res.status == 201){
                    this.$toast.success(res.data.message)
                    location. reload()
                
                }else if(res.status == 204){
                    this.$toast.error('Caracteristica ingresada ya existe.')
                    return
                }
            })
            .catch((error) => error)

            // console.log(objList);
            if(this.codigo == '' || this.descripcion == ''){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{

                let info = {
                    'codigo' : this.codigo,
                    'descripcion' : this.descripcion,
                    'idUser' : this.$store.state.userId
                }

                TipoActivo.createTipoActivo(info)
                .then((res) => {

                    if(res.status == 201){
                        this.$toast.success(res.data.message)
                        location. reload()
                    
                    }else if(res.status == 204){
                        this.$toast.error('Tipo activo ya existe.')
                    }
                })
                .catch((error) => error)
            }
        },
        addCaracteristica(){
            
            // Crear un nuevo div para la fila
            const nuevaFila = document.createElement('div');
            
            // Añadir clase para estilo
            nuevaFila.className = 'fila';
            
            // Crear la primera celda
            const celda1 = document.createElement('div');
            celda1.className = 'celda';
            // celda1.textContent = 'Celda 1'; // Contenido de la primera celda

            const input1 = document.createElement('input');
            input1.type = 'text'; // Tipo de input
            input1.id = 'caracteristica'+cont
            input1.className = 'form-control'
            input1.placeholder = 'Caracteristica'
            celda1.appendChild(input1); // Añadir el input a la primera celda
            
            // Crear la segunda celda
            const celda2 = document.createElement('div');
            celda2.className = 'celda';
            // celda2.textContent = 'Celda 2'; // Contenido de la segunda celda

            const input2 = document.createElement('input');
            input2.type = 'text'; // Tipo de input
            input2.id = 'valor'+cont
            input2.className = 'form-control'
            input2.placeholder = 'Valor'
            celda2.appendChild(input2); // Añadir el input a la segunda celda

            // Agregar las celdas a la fila
            nuevaFila.appendChild(celda1);
            nuevaFila.appendChild(celda2);
            
            // Agregar la nueva fila al contenedor
            document.getElementById('contenedor').appendChild(nuevaFila);
            cantFilaCaract.push(nuevaFila)
            cont = cont + 1
        }
    }
}
</script>

<style>
    .fila {
        display: flex; /* Usamos flexbox para alinear las celdas */
        /* border: 1px solid #000; */
        padding: 4px;
        /* margin: 5px 0; */
    }
    .celda {
        flex: 1; /* Las celdas ocuparán el mismo espacio */
        /* border: 1px solid #ccc; */
        padding: 1px;
        text-align: center;
        margin-left: 10px;
    }
</style>